<template>
  <section class="invoice">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <div class="wrapper">
                <h4 class="card-title">All Projects (342)</h4>
                <p>0 Selected - <span class="text-primary">Select all projects</span></p>
              </div>
              <div class="wrapper">
              </div>
            </div>
            <div class="row project-list-showcase">
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="project-grid-inner">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Logo Design</h5>
                      <p class="project-location">San Francisco, California</p>
                    </div>
                    <div class="badge badge-gradient-success ml-auto">Finished</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">70%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-success" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="70"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>50</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>321</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face1.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face2.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face3.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="project-grid-inner">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Branding Mockup</h5>
                      <p class="project-location">San Francisco, CA</p>
                    </div>
                    <div class="badge badge-gradient-success ml-auto">Finished</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">70%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-danger" role="progressbar" style="width: 30%" aria-valuenow="30" aria-valuemin="0" aria-valuemax="30"></div>
                  </div>
                  <div class="d-flex justify-content-between flex-wrap align-items-center">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>45</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>123</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face12.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face4.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face15.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="project-grid-inner">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Mobile App Design</h5>
                      <p class="project-location">New York, USA</p>
                    </div>
                    <div class="badge badge-gradient-secondary ml-auto">On going</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">50%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-warning" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="50"></div>
                  </div>
                  <div class="d-flex justify-content-between flex-wrap align-items-center">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>50</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>321</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face1.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face2.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face3.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="img-holder img-bg-1">
                </div>
                <div class="project-grid-inner">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Mobile App</h5>
                      <p class="project-location">Austin, Texas</p>
                    </div>
                    <div class="badge badge-gradient-success ml-auto">Finished</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">70%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-info" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="70"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>50</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>321</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face1.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face2.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face3.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="img-holder img-bg-2">
                </div>
                <div class="project-grid-inner">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Dashboard Design</h5>
                      <p class="project-location">Amsterdam, The Netherlands</p>
                    </div>
                    <div class="badge badge-gradient-danger ml-auto">Hold</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">70%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-primary" role="progressbar" style="width: 40%" aria-valuenow="40" aria-valuemin="0" aria-valuemax="40"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>34</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>453</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face9.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face5.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face6.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="img-holder img-bg-3">
                </div>
                <div class="project-grid-inner">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Ecommerce Website</h5>
                      <p class="project-location">Shoreditch, London</p>
                    </div>
                    <div class="badge badge-gradient-secondary ml-auto">On going</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">50%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-warning" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="50"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>65</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>651</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face5.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face3.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face13.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="project-grid-inner">
                  <img class="mb-3 mt-n3" src="@/assets/images/brand_icons/bitmap.jpg" alt="brand image">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Logo Design</h5>
                      <p class="project-location">München, Germany</p>
                    </div>
                    <div class="badge badge-gradient-danger ml-auto">Hold</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">70%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-success" role="progressbar" style="width: 70%" aria-valuenow="70" aria-valuemin="0" aria-valuemax="70"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>34</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>466</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face11.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face12.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face10.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="project-grid-inner">
                  <img class="mb-3 mt-n3" src="@/assets/images/brand_icons/oval-copy.jpg" alt="brand image">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Branding Mockup</h5>
                      <p class="project-location">Russia, Moscow</p>
                    </div>
                    <div class="badge badge-gradient-success ml-auto">Finished</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">25%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-primary" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="25"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>67</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>543</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face9.jpg" alt="profile image">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face8.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-6 col-12 project-grid">
                <div class="project-grid-inner">
                  <img class="mb-3 mt-n3" src="@/assets/images/brand_icons/oval.jpg" alt="brand image">
                  <div class="d-flex align-items-start">
                    <div class="wrapper">
                      <h5 class="project-title">Mobile App Design</h5>
                      <p class="project-location">Odessa, Ukraine</p>
                    </div>
                    <div class="badge badge-gradient-secondary ml-auto">On going</div>
                  </div>
                  <p class="project-description">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.</p>
                  <div class="d-flex justify-content-between">
                    <p class="mb-2 font-weight-medium">Progress</p>
                    <p class="mb-2 font-weight-medium">22%</p>
                  </div>
                  <div class="progress progress-md mb-3">
                    <div class="progress-bar bg-gradient-warning" role="progressbar" style="width: 22%" aria-valuenow="22" aria-valuemin="0" aria-valuemax="22"></div>
                  </div>
                  <div class="d-flex justify-content-between align-items-center flex-wrap">
                    <div class="action-tags d-flex flex-row">
                      <div class="wrapper pr-4"><i class="mdi mdi-view-sequential mr-2"></i>87</div>
                      <div class="wrapper"><i class="mdi mdi-message-outline mr-2"></i>558</div>
                    </div>
                    <div class="image-grouped">
                      <img class="img-xs rounded-circle" src="@/assets/images/faces/face13.jpg" alt="profile image">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'project-list'
}
</script>